export default __webpack_public_path__ + "static/4-5649a143b64fe07a67ab3bcae22f9e00.png";